module.exports = __webpack_public_path__ + "img/cloudview_movie-single.218a0f18.jpg";